import { render, staticRenderFns } from "./MenuItensValor.vue?vue&type=template&id=39959e32&scoped=true"
import script from "./MenuItensValor.vue?vue&type=script&lang=js"
export * from "./MenuItensValor.vue?vue&type=script&lang=js"
import style0 from "./MenuItensValor.vue?vue&type=style&index=0&id=39959e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39959e32",
  null
  
)

export default component.exports